import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { logger } from "redux-logger";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authorizationSlice from "./authorization";
import LanguageSlice from "./lang";
import sessionStorage from "redux-persist/es/storage/session";

const persistConfig = {
  key: "Recycling",
  version: 1,
  storage
};

const reducer = {
  auth: persistReducer({ key: 'recycle-auth', storage: sessionStorage }, authorizationSlice),
  language: persistReducer({ key: 'recycle-lang', storage: sessionStorage }, LanguageSlice)
};

const rootReducer = combineReducers(reducer);
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(logger),
  devTools: process.env.NODE_ENV !== "production",
});

export default store;
